module.exports = __webpack_public_path__ + "static/media/jtmenergy.49c9e338.jpg";